import type { JSX } from 'react';
import { BRAND, COPYRIGHT_YEAR } from '../config/content';
import { COMPANY_LINKS } from '../config/footer-links';
import { SOCIAL_LINKS } from '../config/social-links';

import { FooterLink } from './FooterLink';
import styles from './Footer.module.css';

/**
 * Social accounts on one side, company and legal destinations on the other.
 *
 * Both rows are rendered from config, so the difference between "this link works" and "this
 * label is waiting for a page" is data — an `href` present or absent — rather than two shapes
 * of markup that have to be kept in step.
 */
export function Footer(): JSX.Element {
  return (
    <footer className={styles.footer}>
      <div className={styles.social}>
        {SOCIAL_LINKS.map((link) => (
          <FooterLink
            key={link.label}
            className={styles.item}
            label={link.label}
            href={link.href}
            external
          />
        ))}
      </div>

      <div className={styles.company}>
        {COMPANY_LINKS.map((link) => (
          <FooterLink
            key={link.label}
            className={styles.item}
            label={link.label}
            href={link.href}
          />
        ))}
        <span>
          © {COPYRIGHT_YEAR} {BRAND.name}
        </span>
      </div>
    </footer>
  );
}
